<div
  class="action"
  (mouseover)="actionisHovered = 0"
  (mouseout)="actionisHovered = null"
  (click)="onActionClick(actions[0])"
>
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        id="Vector"
        d="M12 8V16M16 12H8M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        [attr.stroke]="actionisHovered === 0 ? '#ffb800' : '#ffffff'"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
  <div class="action-title">{{ actions[0].label }}</div>
</div>
<div
  class="action"
  (mouseover)="actionisHovered = 1"
  (mouseout)="actionisHovered = null"
  (click)="onActionClick(actions[1])"
>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        id="Vector"
        d="M4.99984 8.33366H5.83317C6.75364 8.33366 7.49984 7.58747 7.49984 6.66699V6.25033C7.49984 5.55997 8.05948 5.00033 8.74984 5.00033C9.44019 5.00033 9.99984 5.55997 9.99984 6.25033V10.417C9.99984 11.1073 10.5595 11.667 11.2498 11.667C11.9402 11.667 12.4998 11.1073 12.4998 10.417V10.0003C12.4998 9.07985 13.246 8.33366 14.1665 8.33366H14.9998M9.99984 15.0003V18.3337M4.99984 15.0003H14.9998C16.8408 15.0003 18.3332 13.5079 18.3332 11.667V5.00033C18.3332 3.15938 16.8408 1.66699 14.9998 1.66699H4.99984C3.15889 1.66699 1.6665 3.15938 1.6665 5.00033V11.667C1.6665 13.5079 3.15889 15.0003 4.99984 15.0003Z"
        [attr.stroke]="actionisHovered === 1 ? '#ffb800' : '#ffffff'"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        id="Vector 1028"
        d="M11.6665 18.333L8.33317 18.333"
        [attr.stroke]="actionisHovered === 1 ? '#ffb800' : '#ffffff'"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </g>
  </svg>
  <div class="action-title">{{ actions[1].label }}</div>
</div>
<div
  class="action"
  (mouseover)="actionisHovered = 2"
  (mouseout)="actionisHovered = null"
  (click)="onActionClick(actions[2])"
>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        id="Vector"
        d="M18.3332 8.33366V15.0003C18.3332 16.8413 16.8408 18.3337 14.9998 18.3337H4.99984C3.15889 18.3337 1.6665 16.8413 1.6665 15.0003V5.00033C1.6665 3.15938 3.15889 1.66699 4.99984 1.66699H11.6665M4.1665 10.0003H4.99984C5.92031 10.0003 6.6665 9.25413 6.6665 8.33366V7.50033C6.6665 6.57985 7.4127 5.83366 8.33317 5.83366C9.25364 5.83366 9.99984 6.57985 9.99984 7.50033V12.5003C9.99984 13.4208 10.746 14.167 11.6665 14.167C12.587 14.167 13.3332 13.4208 13.3332 12.5003V11.667C13.3332 10.7465 14.0794 10.0003 14.9998 10.0003H15.8332M18.3332 3.75033C18.3332 4.90092 17.4004 5.83366 16.2498 5.83366C15.0992 5.83366 14.1665 4.90092 14.1665 3.75033C14.1665 2.59973 15.0992 1.66699 16.2498 1.66699C17.4004 1.66699 18.3332 2.59973 18.3332 3.75033Z"
        [attr.stroke]="actionisHovered === 2 ? '#ffb800' : '#ffffff'"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </g>
  </svg>
  <div class="action-title">{{ actions[2].label }}</div>
</div>
<div
  class="action"
  (mouseover)="actionisHovered = 3"
  (mouseout)="actionisHovered = null"
  (click)="onActionClick(actions[3])"
>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        id="Vector"
        d="M7.49984 3.51966C4.15986 4.27755 1.6665 7.26451 1.6665 10.8338C1.6665 14.976 5.02437 18.3338 9.1665 18.3338C12.7358 18.3338 15.7228 15.8405 16.4807 12.5005M11.6559 1.83169C14.9297 2.49178 17.5085 5.07064 18.1686 8.34445C18.3506 9.24677 17.587 10.0005 16.6665 10.0005H11.6665C10.746 10.0005 9.99984 9.25429 9.99984 8.33381V3.33381C9.99984 2.41334 10.7535 1.64976 11.6559 1.83169Z"
        [attr.stroke]="actionisHovered === 3 ? '#ffb800' : '#ffffff'"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </g>
  </svg>
  <div class="action-title">{{ actions[3].label }}</div>
</div>
